<template>
  <div
    v-if="stage === 'released'"
    class="text-center"
  >
    <p>
      <span class="display-block">Your early backing gets you a</span>
      <strong class="display-block size-lg margin-top-2xs">full year of Pro services.</strong>
    </p>
  </div>

  <div
    v-else-if="stage === 'alerting' || stage === 'grace-period'"
    class="text-center"
  >
    <p>
      <span class="display-block">Your year of Pro services for backing FA5 expires on:</span>
      <strong class="display-block size-lg margin-top-2xs">{{ expiresDateFormatted }}!</strong>
    </p>

    <template v-if="allowPlanActions">
      <site-link
        :to="{ name: 'plans' }"
        class="link primary"
      >
        Start a Subscription
      </site-link>
    </template>
  </div>

  <div
    v-else-if="stage === 'shutoff'"
    class="text-center"
  >
    <p>
      <span class="display-block">Your year of Pro services for backing FA5 expired on:</span>
      <strong class="display-block size-lg margin-top-2xs">{{ expiresDateFormatted }}!</strong>
    </p>

    <site-link
      v-if="allowPlanActions"
      :to="{ name: 'plans' }"
      class="link primary"
    >
      Start a Subscription
    </site-link>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'PreOrderBackerStatus',

    props: {
      determinations: {
        type: Object,
        required: true
      },

      preOrderBackerDates: {
        type: Object,
        required: true
      },

      allowPlanActions: {
        type: Boolean,
        required: true
      }
    },

    computed: {
      stage() {
        return this.determinations.preOrderBackerStage
      },

      expiresDateFormatted() {
        return moment(this.preOrderBackerDates.expires).format('MMMM D, YYYY')
      }
    }
  }
</script>
